import { LOGIN_SUCCESS, LOGOUT_SUCCESS, UPDATE_USER_DATA } from "../actions/authAction";

const initialState = {
  isLoggedIn: false,
  userData: {}
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case UPDATE_USER_DATA:
      return {
        ...state,
        userData: { ...action.payload }
      }
    default:
      return state;
  }
};

export default authReducer;
